import type { ReactNode } from 'react';
import type { StudioState } from '@/lib/studio/studioState';
import { StudioCtx } from './studioHooks';

export function StudioStateProvider({ value, children }: { value: StudioState | null; children: ReactNode }) {
  return <StudioCtx.Provider value={value}>{children}</StudioCtx.Provider>;
}
